import { TargetEntityTypeResponse } from '../../../../web-api-client';
import { TargetEntityType } from '../../models/target-entity-type';

export const mapTargetEntityTypeFromResponse = (
  response: TargetEntityTypeResponse
): TargetEntityType => ({
  entityTypeId: response.entityTypeId!,
  name: response.name!,
  isDefault: response.isDefault!,
});
